import { Grid, Paper, Typography } from "@mui/material";
import { Observer } from "mobx-react";
import React from "react";
import { useStore } from "../../../../utils/useStore";
import { EvalLicensedModule, EvalStore } from "../../Stores/EvalStore";
import InProgressWorkflowsMessage from "./InProgressWorkflowsMessage";
import ModuleCardFooter from "./ModuleCardFooter";
import ModuleCardHeader from "./ModuleCardHeader";
import QuestionAnswerList from "./QuestionAnswerList";
import { useTheme } from "@mui/material";

interface OwnProps {
    module?: EvalLicensedModule;
}

const ModuleCard = (props: OwnProps) => {
    const theme = useTheme();
    const store = useStore(EvalStore);
    return (
        <Observer>
            {() => {
                return (
                    <Paper
                        sx={{
                            paddingBottom: "16px",
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            marginTop: "2.0rem",
                            marginBottom: "2.0rem",
                        }}
                        elevation={4}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="stretch"
                            sx={{ paddingLeft: 2, paddingRight: 2 }}
                        >
                            {store.hasInProgressWorkflows && (
                                <InProgressWorkflowsMessage />
                            )}
                            <Grid
                                item
                                xs={12}
                                sx={{
                                    paddingLeft: theme.spacing(3),
                                    paddingTop: theme.spacing(3),
                                    paddingBottom: theme.spacing(1),
                                    marginBottom: "16px",
                                }}
                            >
                                <Typography variant={"h1"}>
                                    {props.module?.name}
                                </Typography>
                            </Grid>
                            <ModuleCardHeader module={props.module} />
                            <QuestionAnswerList
                                store={store}
                                module={props.module}
                            />
                            <ModuleCardFooter module={props.module} />
                        </Grid>
                    </Paper>
                );
            }}
        </Observer>
    );
};

export default ModuleCard;
